import { LoadState } from "../../constants/enums";

export interface IQuotesRequestState {
  list: IQuotesRequest[];
  quote: IQuotesRequest;
  loading: LoadState;
  error: string | null;
}

export interface IQuotesRequest {
  quote_reference_number: string | null;
  quote_id: string | null;
  insurer: string | null;
  insured_name: string | null;
  type: string | null;
  name: string;
  province: string | null;
  phone: string;
  email: string;
  effective_date: string | null;
  source: string | null;
  reason: string | null;
  remarks: string | null;
  created_by: string | null;
  date_created: string | null;
  attachment: string | string[] | null;
  branch_code: string | null;
  producer_code: string | null;
  status: string;
  customer_id?: number | null;
  customer_policy_id?: number | null;
  inserting_list?: string[];
}

export const INITIAL_QUOTES: IQuotesRequest =  {
    quote_reference_number: null,
    quote_id: null,

    insurer: null,
    insured_name: null,
    type: null,
    branch_code: null,
    producer_code: null,
    name: "",
    province: null,
    phone: "",
    email: "",
    effective_date: null,
    source: "ARS",
    created_by: null,
    date_created: null,
    attachment: null,
    status: "",
    remarks: null,
    reason: null,
    inserting_list: [
      "driver",
      "claims",
      "vehicle",
      "coverage",
      "risk_location",
    ]
  }

export const initialQuoteReqState: IQuotesRequestState = {
  list: [],
  quote: INITIAL_QUOTES,
  loading: LoadState.NotLoaded,
  error: null,
};
